import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=40e2eb6f&scoped=true&"
import script from "./MenuBar.vue?vue&type=script&lang=js&"
export * from "./MenuBar.vue?vue&type=script&lang=js&"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=40e2eb6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2eb6f",
  null
  
)

export default component.exports